export default {
  async authenticateByJWT(request, params = '') {
    return request + (params ? '?' + params : '');
  },
};
